import type { PaletteOptions } from '@mui/material/styles';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: { main: '#4F46E5', contrastText: '#FFFFFF' },
  secondary: { main: '#F59E0B', contrastText: '#1F2937' },
  error: { main: '#DC2626' },
  background: { default: '#FAFAFA', paper: '#FFFFFF' },
  text: { primary: '#1F2937', secondary: '#4B5563' },
  divider: 'rgba(31, 41, 55, 0.12)',
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: { main: '#818CF8', contrastText: '#0F0F14' },
  secondary: { main: '#FBBF24', contrastText: '#0F0F14' },
  error: { main: '#F87171' },
  background: { default: '#0F0F14', paper: '#1A1B23' },
  text: { primary: '#E5E7EB', secondary: '#9CA3AF' },
  divider: 'rgba(229, 231, 235, 0.12)',
};
